// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ff5c0ffb","556":"bbe98073"}[chunkId] + ".chunk.js";
};